import { styled, Typography } from '@mui/material'
import ApeironSnackNotify from '@src/components/share/apeiron/ApeironSnackNotify'
import ENV_CONFIG from '@src/config'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const StyledApeironSnackNotify = styled(ApeironSnackNotify)`
  position: absolute;
  top: 5px;
  z-index: 0; // 1400 (default) to 0

  .Custom-Container {
    align-items: flex-start;
    gap: 4px;
  }
`

const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  white-space: pre-wrap;
`

const Description = styled(Typography)`
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  white-space: pre-wrap;
`

const Report = styled('a')`
  color: #8d7cff;
  font-size: 16px;
  font-weight: 500;
`

const BattleDemoCheaterWarning: FC<Props> = () => {
  const { t } = useTranslation()

  const email = ENV_CONFIG.EMAIL_URL.SUPPORT

  return (
    <StyledApeironSnackNotify notifyKey='battle_demo_leaderboard_cheater_warning'>
      <Title>{t('battle_demo.leaderboard.cheat_warning_title')}</Title>
      <Description>
        <Trans
          components={{
            report: <Report href={`mailto:${email}`} />
          }}
        >
          {t('battle_demo.leaderboard.cheat_warning', { email })}
        </Trans>
      </Description>
    </StyledApeironSnackNotify>
  )
}

type Props = {}

export default BattleDemoCheaterWarning
